import { render, staticRenderFns } from "./TemplatesPage.vue?vue&type=template&id=34fa3752"
import script from "./TemplatesPage.vue?vue&type=script&lang=js"
export * from "./TemplatesPage.vue?vue&type=script&lang=js"
import style0 from "./TemplatesPage.vue?vue&type=style&index=0&id=34fa3752&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports